module.exports = __webpack_public_path__ + "lp/img/vote_good_active.4caaf3bd.svg";